// extracted by mini-css-extract-plugin
export default {"container":"BlogsPage_container__L2sq4"};